export const cookieTypeKeys = {
  necessary: "necessary",
  analytics: "analytics"
}

export const COOKIE_CONSENT_REQUIRED_COUNTRIES = [
  // European Union (EU) countries
  "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czechia", "Denmark", "Estonia", "Finland",
  "France", "Germany", "Greece", "Hungary", "Ireland", "Italy", "Latvia", "Lithuania", "Luxembourg", "Malta",
  "The Netherlands", "Poland", "Portugal", "Romania", "Slovakia", "Slovenia", "Spain", "Sweden",

  // Non-EU countries requiring opt-in consent
  "United Kingdom", "Switzerland", "Norway", "Iceland", "Liechtenstein",

  // Other jurisdictions requiring explicit opt-in consent
  "Brazil", "South Korea", "China", "Japan", "Thailand", "South Africa"
];

export const GOOGLE_ANALYTICS_BANNED_COUNTRIES = [
  "Austria", "France", "Italy", "Denmark", "Finland", "Norway", "Sweden"
];
